import Head from 'next/head';
import Index from '@@/containers/h5/home/components/Character/components/CharacterDetail';
import '@@/styles/swiper';
import { store, reducer } from '@@/store/home';
import HeadSeo from '@/components/head-seo';
import StoreProvider from '@/components/store-provider';
import { getPageData } from '@/model/page';

const CharacterDetail = ({ pageData }) => {
  return (
    <>
      <HeadSeo image={pageData?.page?.share_img?.[0]?.value} />
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            document.documentElement.classList.add('m-app');
            `,
          }}
        />
      </Head>
      <StoreProvider store={store} reducer={reducer}>
        <Index pageData={pageData?.page} />
      </StoreProvider>
    </>
  );
};

export default CharacterDetail;

export const getServerSideProps = async () => {
  let data = {};
  try {
    data = await getPageData();
  } catch (error) {
    throw new Error(error);
  }
  return {
    props: {
      pageData: data,
    },
  };
};
